import axios from 'axios'
import styled from 'styled-components'
const apiUrl =
    process.env.NODE_ENV === 'production'
        ? '/api'
        : process.env.REACT_APP_API_URL
const StyledDeleteContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(158, 18, 18, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`
const StyledDeleteBox = styled.div`
    width: 80%;
    height: 80%;
    background-color: #5c83ab;
    display: flex;
    justify-content: center;
    align-items: center;
`

const StyledDeleteButton = styled.button`
    width: 100%;
    padding: 10px;
    background-color: #a21111;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background-color: #8a0e0e;
    }
`
const StyledReturnButton = styled.button`
    width: 100%;
    padding: 10px;
    background-color: #ffffff;
    color: black;
    border: none;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background-color: #a3a3a3;
    }
`

const DeleteProfile = ({ setIsDeleteVisible, userInfo }) => {
    const handleClickClose = () => {
        setIsDeleteVisible(false)
    }

    const handleDeleteThing = async () => {
        try {
            const response = await axios.delete(
                `${apiUrl}/auth/${userInfo._id}`,
                {
                    withCredentials: true,
                }
            )
            console.log('Réponse du serveur:', response.data)
            window.location.replace('/')
        } catch (error) {
            console.error(
                'Erreur lors de la requête:',
                error.response ? error.response.data : error.message
            )
        }
    }

    return (
        <StyledDeleteContainer>
            <StyledDeleteBox>
                <h2>Supprimer profile</h2>
                <div>Voulez-vous vraiment supprimer ?</div>
                <StyledReturnButton onClick={handleClickClose}>
                    Annuler
                </StyledReturnButton>
                <StyledDeleteButton onClick={handleDeleteThing}>
                    Supprimer
                </StyledDeleteButton>
            </StyledDeleteBox>
        </StyledDeleteContainer>
    )
}

export default DeleteProfile
